import hasText from './hasText';
import walk from './walk';
import isIAudio from './node/isIAudio';
import isIBanner from './node/isIBanner';
import isIContainer from './node/isIContainer';
import isIGradedText from './node/isIGradedText';
import isIImage from './node/isIImage';
import isIPadding from './node/isIPadding';
import isISeparator from './node/isISeparator';
import isISpan from './node/isISpan';
import isIVideo from './node/isIVideo';
function enumeration(value, index = 0) {
    return value.length * (value.charCodeAt(index) + 119);
}
function text(str, value, max = 128) {
    for (let i = Math.min(str.length, max); i;) {
        value += value * 33 ^ str.charCodeAt(--i);
    }
    return value;
}
export function hash(node) {
    let value = 5381;
    walk(node, n => {
        value += enumeration(n.type);
        if (hasText(n)) {
            value += text(n.text, value);
        } else if (isIGradedText(n)) {
            value += text(n.wordGrades.map(wordGrade => wordGrade.word).join(' '), value);
        } else if (isIAudio(n) || isIImage(n) || isIVideo(n)) {
            value += text(`${ n.url }`, value);
        } else if (isISeparator(n)) {
            value += enumeration(n.thickness);
        } else if (isISpan(n)) {
            value += enumeration(n.alignment);
        } else if (isIContainer(n) || isIBanner(n)) {
            value += enumeration(n.layout);
        } else if (isIPadding(n)) {
            value += enumeration(n.size);
        }
    });
    return value >>> 0;
}
export default hash;    //# sourceMappingURL=hash.js.map
